
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Pages": () => {
return Promise.all(/*  | __federation_expose_Pages */ [__webpack_require__.e("7225"), __webpack_require__.e("2305"), __webpack_require__.e("2015"), __webpack_require__.e("6436"), __webpack_require__.e("723"), __webpack_require__.e("2167"), __webpack_require__.e("4068"), __webpack_require__.e("732"), __webpack_require__.e("3294"), __webpack_require__.e("8102"), __webpack_require__.e("9707"), __webpack_require__.e("7042"), __webpack_require__.e("8191"), __webpack_require__.e("1733"), __webpack_require__.e("5206"), __webpack_require__.e("7825"), __webpack_require__.e("1889")]).then(() => (() => (__webpack_require__(52083))));
},
"./Hooks": () => {
return __webpack_require__.e(/*  | __federation_expose_Hooks */ "3597").then(() => (() => (__webpack_require__(41397))));
},
"./Reducers": () => {
return Promise.all(/*  | __federation_expose_Reducers */ [__webpack_require__.e("2015"), __webpack_require__.e("8102"), __webpack_require__.e("8340")]).then(() => (() => (__webpack_require__(70056))));
},
"./Sagas": () => {
return Promise.all(/*  | __federation_expose_Sagas */ [__webpack_require__.e("2015"), __webpack_require__.e("1576"), __webpack_require__.e("8102"), __webpack_require__.e("7042"), __webpack_require__.e("5206"), __webpack_require__.e("2308")]).then(() => (() => (__webpack_require__(26634))));
},
"./Actions": () => {
return Promise.all(/*  | __federation_expose_Actions */ [__webpack_require__.e("2015"), __webpack_require__.e("8102"), __webpack_require__.e("4250")]).then(() => (() => (__webpack_require__(97295))));
},
"./Utils": () => {
return __webpack_require__.e(/*  | __federation_expose_Utils */ "8508").then(() => (() => (__webpack_require__(93150))));
},
"./Types": () => {
return __webpack_require__.e(/*  | __federation_expose_Types */ "2528").then(() => (() => (__webpack_require__(85852))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };